<template>
    <div id="app">
        <router-view></router-view>
        <wwdfooter></wwdfooter>
    </div>
</template>

<script>
// import wwdheader from '@/components/wwdheader.vue'
import wwdfooter from "@/components/wwdfooter.vue";

export default {
    name: "app",
    components: {
        wwdfooter: wwdfooter
    }
};
</script>

<style lang="scss">
@import "@/styles/index";
</style>
